<template>
  <WdsStack direction-column gap-lg align-center>
    <WdsAvatar xxl :path="randomAvatar" />

    <WdsStack direction-column gap-xs align-center>
      <WdsHeading type="title2">{{ title }}</WdsHeading>
      <WdsText large tertiary>
        <div class="tw-font-base">
          {{ description }}
        </div>
      </WdsText>
    </WdsStack>

    <WdsStack direction-row gap-md>
      <a
        v-if="!hideStatusButton"
        href="https://status.worksome.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        <WdsButton lg secondary>{{ $t('Check platform status') }}</WdsButton>
      </a>

      <WdsButton lg primary @click="handleButtonClick">{{ buttonText }}</WdsButton>
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsAvatar, WdsButton, WdsHeading, WdsStack, WdsText } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { getRandomAvatarPath } from '@/utils/avatar'

interface Props {
  title?: string
  description?: string
  buttonText?: string
  onButtonClick?: () => void
  hideStatusButton?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  title: () => $t(`This is embarrassing, we couldn't load this content`),
  description: () =>
    $t('Please try refreshing the page or check our platform status for any known issues'),
  buttonText: () => $t('Refresh page'),
  onButtonClick: undefined,
})

const randomAvatar = getRandomAvatarPath()

const defaultRefreshPage = () => {
  window.location.reload()
}

const handleButtonClick = () => {
  if (props.onButtonClick) {
    props.onButtonClick()
  } else {
    defaultRefreshPage()
  }
}
</script>
